// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Loader_loadingContainer__2cSLF","indicator":"Loader_indicator__Y7Aei"};